import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class ExcludedAccountSearchCriteria extends ValueObject {
    
    public searchCriteria: string = "";
}